import React, {Component} from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import {CommonUtil} from "../utils/CommonUtil";
import ModalGallery from "./ModalGallery";
import ModalContacts from "./ModalContacts";
import {withTranslation} from "react-i18next";
import Constants from "./Constants";
import HelpButton from "./HelpButton";
import ModalContactsShort from "./ModalContactsShort";

class AllControlsContainer extends Component {

    constructor(props) {
        super(props);

        this.imageSrc = null;
        this.modalGalleryRef = React.createRef();
        this.modalContactsRef = React.createRef();
        this.modalContactsShortRef = React.createRef();
        this.imageReLoader = null;
        this.imageReScaler = null;

        this.state = {
            dropdownOpen: false,
            canvasArray: [],
            isBgExist: false,
            isFullScreen: false
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.onOrientationChangeOrResize);
        window.addEventListener("orientationchange", this.onOrientationChangeOrResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onOrientationChangeOrResize);
        window.removeEventListener('orientationchange', this.onOrientationChangeOrResize);
        if(this.imageReLoader) this.imageReLoader.clearInterval();
        if(this.imageReScaler) this.imageReScaler.clearInterval();
    }

    onOrientationChangeOrResize = (event) => {
        if(this.state.isBgExist) {
            /*
            * we need to call function with delay in order dimensions are rerendered
            * because they are changed in .css at changing orientation
            * */
            this.imageReLoader = setTimeout(this.reloadImage, 500);
        } else {
            this.imageReScaler = setTimeout(this.clearCanvas, 500);
        }
    };

    reScaleImageCanvas = () => {
        let canvas = document.getElementById('imageBgCanvas');
        let imc = document.getElementsByClassName('imageBgContainer');

        let containerWidth = parseInt(imc[0].clientWidth);
        let containerHeight = parseInt(imc[0].clientHeight);

        canvas.width = containerWidth;
        canvas.height = containerHeight;
        canvas.style.left = 0 + 'px';
        canvas.style.top = 0 + 'px';

        this.clearImageCanvas(canvas, containerWidth, containerHeight);
    };

    onLoadFromGalleryClick = () => {
        if(document.fullscreen){
            /*
            * We need to hide browser fullscreen API modal window and then make it visible again
            * */
            document.getElementById('root').style.display = 'none';
        }
        this.modalGalleryRef.current.toggleModal();
    };

    onContactsClick = () => {
        if(document.fullscreen){
            /*
            * We need to hide browser fullscreen API modal window and then make it visible again
            * */
            //document.getElementById('root').style.display = 'none';
            /*
            * All sub elements in fullscreen are inactive,
            * so we have to cancel from fullscreen mode in order all the inputs to be active
            * https://developer.mozilla.org/en-US/docs/Web/CSS/:fullscreen
            * */
            document.exitFullscreen();
        }
        switch (Constants.HOST_WEBSITE) {
            case 'ddn':
                this.modalContactsRef.current.toggleModal();
                break;
            case '3d-sofa':
                this.modalContactsShortRef.current.toggleModal();
                break;
            default:
                console.log(`Sorry, we are out of ${Constants.HOST_WEBSITE}.`);
        }

    };

    onLoadFromDeviceClick = () => {
        document.getElementById('file').click();
        document.getElementById('file').addEventListener('change', (event) => {
            this.onFileSelected(event);
        });
    };

    removeBg = () => {
        this.setState({
            isBgExist: false
        });
        this.clearCanvas();
    };

    reloadImage = () => {
        if(this.state.isBgExist) {
            let img = new Image();
            img.onload = () => this.getImageData(img);
            img.src = this.imageSrc;
        }
    };

    onFileSelected = (evt) => {
        let tgt = evt.target || window.event.srcElement,
            files = tgt.files;

        // FileReader support
        if (FileReader && files && files.length) {
            let file = files[0];
            let fr = new FileReader();
            fr.onload = () => this.showImage(fr);
            fr.readAsDataURL(file);
        }
    };

    showImage = (fileReader) => {
        this.setState({
            isBgExist: true
        });

        let img = new Image();
        img.onload = () => this.getImageData(img);
        img.src = fileReader.result;
        this.imageSrc = img.src;
    };

    onBgImageClick = (e) => {
        if(document.fullscreen) {
            document.getElementById('root').style.display = 'flex';
        }

        this.modalGalleryRef.current.toggleModal();
        this.setState({
            isBgExist: true
        });

        let img = new Image();
        img.onload = () => this.getImageData(img);
        img.src = e.currentTarget.src;
        this.imageSrc = img.src;
    };

    getImageData = (img, w, h) => {
        let canvas = document.getElementById('imageBgCanvas');
        let imageBgContainer = document.getElementById('imageBgContainer');
        let containerWidth = parseInt(imageBgContainer.clientWidth);
        let containerHeight = parseInt(imageBgContainer.clientHeight);
        let originalWidth = w ? img.naturalWidth : img.width;
        let originalHeight = h ? img.naturalHeight : img.height;

        //this.clearImageCanvas(canvas, containerWidth, containerHeight);
        this.clearCanvas();

        console.log("ORIG : " + originalWidth + ' : ' + originalHeight + ' :: ' + containerWidth + ' : ' + containerHeight + ' ::: ' + img.width + ' : ' + img.height);

        let fittedImage = CommonUtil.scaleImage(originalWidth, originalHeight, containerWidth, containerHeight, true);
        canvas.width = parseInt(fittedImage.width);
        canvas.height = parseInt(fittedImage.height);
        canvas.style.left = fittedImage.targetleft + 'px';
        canvas.style.top = fittedImage.targettop + 'px';

        console.log(fittedImage.width + ' : ' + fittedImage.height + ' :: ' + fittedImage.targetleft + ' : ' + fittedImage.targettop);

        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, parseInt(fittedImage.width), parseInt(fittedImage.height));         // draw the image
        canvas.toDataURL("image/png");

        this.props.onImageIsLoaded();
    };

    clearCanvas = () => {
        let canvas = document.getElementById('imageBgCanvas');

        let imageBgContainer = document.getElementById('imageBgContainer');
        let containerWidth = parseInt(imageBgContainer.clientWidth);
        let containerHeight = parseInt(imageBgContainer.clientHeight);
        this.clearImageCanvas(canvas, containerWidth, containerHeight);

        canvas.style.width = '100%';
        canvas.style.height = '100%';
    };

    clearImageCanvas = (canvas, w, h) => {
        const context = canvas.getContext('2d');
        context.clearRect(0, 0, w, h);

        context.beginPath();
        context.rect(0, 0, w, h);
        context.fillStyle = Constants.SCENE_BG_COLOR_AFTER_LOADING;
        context.fill();
        console.log(w + ' ww ' + h);
    };

    toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    };

    onFullScreenClick = (e) => {
        let rootContainerRef = document.getElementById('root');

        if (document.fullscreenElement) {
            document.exitFullscreen()
                .then(() => console.log("Document Exited form Full screen mode"))
                .catch((err) => console.error(err))
        } else {
            if (rootContainerRef.requestFullscreen) {
                rootContainerRef.requestFullscreen();
            } else if (rootContainerRef.webkitRequestFullscreen) {// Safari
                rootContainerRef.webkitRequestFullscreen();
            } else if (rootContainerRef.msRequestFullscreen) { // IE11
                rootContainerRef.msRequestFullscreen();
            }
        }

        /*if (document.fullscreenElement) {
            // exitFullscreen is only available on the Document object.
            document.exitFullscreen();
        } else {
            rootContainerRef.requestFullscreen();
        }*/

        this.setState({
            isFullScreen: Boolean(!document.fullscreenElement)
        })
    };

    render() {
        const { t } = this.props;

        const modalForm = (Constants.HOST_WEBSITE === '3d-sofa') ?
            <ModalContactsShort
                ref={this.modalContactsShortRef}
                translation={{t}}/> :
            <ModalContacts
                ref={this.modalContactsRef}
                onSendFeedbackClick={this.props.onSendFeedbackClick}
                translation={{t}}
            />;

        return (
            <div id="allControlsContainer" className="allControlsContainer">
                <div className='zoomControls'>
                    <div className="commonRoundBtn">
                        <span id="minusSign" onClick={this.props.onClick} className="roundedSpan"></span>
                    </div>
                    <div className="commonRoundBtn">
                        <span id="plusSign" onClick={this.props.onClick} className="roundedSpan"></span>
                    </div>
                </div>

                <div className='topControlsContainer'>
                    <div className="commonControl"
                         onClick={this.onContactsClick}>
                        <span className="commonRoundBtn roundBtn">{t('ORDER_TITLE')}</span>
                    </div>
                    <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} className="commonControl">
                        <DropdownToggle className='dropDownToggleItem' tag="a" caret>
                            <span className="commonRoundBtn roundBtn">{t('BG_PHOTO_TITLE')}</span>
                        </DropdownToggle>
                        <DropdownMenu right>
                            <DropdownItem className='photoDropDownItem' onClick={this.onLoadFromGalleryClick}>
                                <span className="roundBtn">{t('BG_PHOTO_SUBTITLE_1')}</span>
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem className='photoDropDownItem' onClick={this.onLoadFromDeviceClick}>
                                <input
                                    type="file"
                                    id="file"
                                    name="file"
                                    className="input-file"
                                    accept="image/*"
                                    onChange={this.onFileSelected}
                                />
                                <span className="roundBtn">{t('BG_PHOTO_SUBTITLE_2')}</span>
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem className='photoDropDownItem' onClick={this.removeBg} disabled={!this.state.isBgExist}>
                                <span className="roundBtn">{t('BG_PHOTO_SUBTITLE_3')}</span>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown >

                    <HelpButton/>
                </div>

                <div className='commonControl logoContainer centered'>
                    <a id="logo_bold" href={'https://3d-sofa.com'} target="_blank" rel="noopener noreferrer">3D</a>
                    <a id="logo" href={'https://3d-sofa.com'} target="_blank" rel="noopener noreferrer">sofa</a>
                </div>

                <div id='fullScreenContainer' className='commonControl fullScreenIconContainer centered' onClick={this.onFullScreenClick}>
                    <span className="material-icons">{this.state.isFullScreen ? 'fullscreen_exit' : 'fullscreen'}</span>
                </div>

                <ModalGallery
                    ref={this.modalGalleryRef}
                    onClick={this.onBgImageClick}
                    translation={{t}}
                />
                {modalForm}
            </div>
        )
    }
}
export default withTranslation('common')(AllControlsContainer);
